import React, { useEffect } from 'react';
import { Box, Alert, Typography } from '@mui/material';
import SalesChannelForm from '../components/SalesChannelForm';
import { trackFunnelStep } from '../analytics';

const ChannelSetupPage = ({
  channelFormData,
  handleChannelInputChange,
  handleChannelSubmit,
  isSubmitting,
  error,
}) => {
  useEffect(() => {
    trackFunnelStep('onboarding_started');
  }, []);

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
          Sales channels represent where you sell your items.
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Examples: eBay, Facebook Marketplace, Poshmark, local antique store, flea market, etc.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          You can always add more channels later from the Channels page.
        </Typography>
      </Alert>

      <SalesChannelForm
        channelFormData={channelFormData}
        onInputChange={handleChannelInputChange}
        onSubmit={handleChannelSubmit}
        isSubmitting={isSubmitting}
        submitLabel="Create Channel & Get Started"
      />
    </Box>
  );
};

export default ChannelSetupPage;
